import { Button, message } from 'antd';
import React, { useEffect, useRef } from 'react';
import { DisconnectOutlined } from '@ant-design/icons';

import { useAppSelector } from 'flex/utils';
import { userManagementTabFlex } from 'flex/view/UsersManagement/UserManagementTab';
import DownloadCSVConfirm from 'components/modules/DownloadCSVConfirm';
import * as Actions from 'flex/Actions';

type Props = {
    tabSelector: UserManagementTabState;
    handleCsvDownload: (
        encoding: Encoding,
        options?: Record<string, unknown>,
    ) => void;
    handleOpenMfaBulkDisableModal: () => void;
};

const MfaToolbar: React.FC<Props> = ({
    tabSelector,
    handleCsvDownload,
    handleOpenMfaBulkDisableModal,
}) => {
    // 多要素認証解除connection セレクタ
    const usersDisableTwoFactorAuthConnection = useAppSelector(
        (state) => state.usersDisableTwoFactorAuthConnection,
    );

    // セレクタ
    const { csvExportLoading } = useAppSelector(
        userManagementTabFlex.selectors.loading,
    );
    const { visibleResetPasswordButton } = useAppSelector(
        userManagementTabFlex.selectors.visible,
    );
    const { csvExportDisabled } = useAppSelector(
        userManagementTabFlex.selectors.disabled,
    );
    const csvExportDisabledMsg = useAppSelector(
        userManagementTabFlex.selectors.csvExportDisabledMsg,
    );

    const prevDisableFetch = useRef(false);

    // 多要素認証設定解除完了時
    // リクエスト中(fetch=true) → 完了(fetch=false) への遷移かつ成功時のみメッセージを表示する。
    // ストアに残った成功ステータスにより、再表示（別ページ経由での再遷移）時に
    // メッセージが意図せず表示されるのを防ぐ。
    useEffect(() => {
        const { fetch, status } = usersDisableTwoFactorAuthConnection.meta;
        if (
            prevDisableFetch.current &&
            !fetch &&
            status === Actions.statusEnum.SUCCESS
        ) {
            message.success('多要素認証設定の解除に成功しました');
        }
        prevDisableFetch.current = fetch;
    }, [usersDisableTwoFactorAuthConnection]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className='flex-right-container gutter-bottom'>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                {/* 多要素認証設定を解除（一括）: コントロールユーザのみ表示 */}
                {visibleResetPasswordButton ? (
                    <Button
                        disabled={
                            (tabSelector.selectedRows ?? []).concat(
                                tabSelector.currentSelectedRows,
                            ).length === 0
                        }
                        icon={<DisconnectOutlined />}
                        loading={usersDisableTwoFactorAuthConnection.meta.fetch}
                        onClick={handleOpenMfaBulkDisableModal}
                        type='primary'
                    >
                        多要素認証設定を解除
                    </Button>
                ) : null}

                {/* MFA管理のCSVエクスポートでは「UUIDを出力する」を表示しない (#4944) */}
                <DownloadCSVConfirm
                    disabled={csvExportDisabled}
                    disabledMessage={csvExportDisabledMsg}
                    handleOk={handleCsvDownload}
                    loading={csvExportLoading}
                />
            </div>
        </div>
    );
};

export default MfaToolbar;
